import { render, staticRenderFns } from "./RequestResetPassword.vue?vue&type=template&id=3d058d00&scoped=true"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js"
import style0 from "./RequestResetPassword.vue?vue&type=style&index=0&id=3d058d00&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d058d00",
  null
  
)

export default component.exports